module.exports = __webpack_public_path__ + "img/Mil.fd5211ea.jpg";